<template>
  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" style="height: 100%;" >
    <div class="card h-100 pb-3 pt-3">
      <div class="card-header">
        <div class="form-group">
          <label class="ml-2" style="font-size: 14px;margin-right: 10px">
            Notifications:
          </label>
          <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : isNotifications, 'bootstrap-switch-off bootstrap-switch-focused' : !isNotifications }">
            <div class="bootstrap-switch-container" @click="updateIsNotificationsForUser()">
              <span class="bootstrap-switch-handle-on bootstrap-switch-primary">On</span>
              <span class="bootstrap-switch-label"></span>
              <span class="bootstrap-switch-handle-off bootstrap-switch-default">Off</span>
            </div>
          </div>
          <span class="ml-2 text-primary cursor-pointer" v-if="muteNotiFlag" v-on:click="toggleMute(false)"><i class="fa fa-bell"></i></span>
          <span class="ml-2 text-primary cursor-pointer" v-else v-on:click="toggleMute(true)"><i class="fa fa-bell-slash"></i></span>
        </div>
        <div class="form-group col-md-6 pl-0">
          <label class="ml-2" style="font-size: 14px">
            Select Plans <i data-toggle="tooltip" title="Enable monitor alerts for specific plans only. By default, all plans are selected." class="fa fa-info-circle make-cursor-pointer"></i>
            <i @click="showPlans = !showPlans" data-toggle="tooltip" title="Preview dropdown for selecting plans" v-if="!showPlans" class="fa fa-eye ml-10 make-cursor-pointer text-primary"></i>
            <i @click="showPlans = !showPlans" v-else data-toggle="tooltip" title="Hide dropdown" class="fa fa-eye-slash ml-10 make-cursor-pointer text-primary"></i>
          </label>
          <template v-if="showPlans">
            <multiSelect :multiple="true" v-model="selectedPlansForMonitorAlerts" placeholder="Select Plans" :options="allPlans"></multiSelect>
            <button :disabled="savePlansLoading" @click="saveSelectedPlans" class="btn btn-sm"><i class="fa fa-save mr-10"></i>Save</button>

          </template>
          </div>
        <div class="row" v-if="currentOpenTab === 0">
          <div class=" col-md-9">
            <div class="buttons">
              <button :disabled="opBtnLoading" @click="syncMonitors()" class="btn btn-primary btn-sm mr-3" >
                <span>Sync Monitors</span>
              </button>
              <button :disabled="refreshTagLoader" @click="syncMonitorTags()" class="btn btn-primary btn-sm mr-3" >
                <span>Refresh Tags</span>
              </button>
              <button v-if="user.userType === 'super-admin'" :disabled="refreshTagLoader" @click="openModalForGeneratingReport()" class="btn btn-primary btn-sm mr-3" >
                <span>Generate Report</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-9">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
<!--              <li class="nav-item">-->
<!--                <a @click="changeTab(0)" class="nav-link active" id="up-tab" data-toggle="tab" href="#up" role="tab" aria-controls="up">Current Outages</a>-->
<!--              </li>-->
              <li class="nav-item">
                <a @click="changeTab(6)" class="nav-link active" id="up-zabbix-tab" data-toggle="tab" href="#upZabbix" role="tab" aria-controls="up">Current Outages</a>
              </li>
              <li class="nav-item">
                <a @click="changeTab(1)" class="nav-link" id="down-tab" data-toggle="tab" href="#down" role="tab" aria-controls="down">Recent Outages</a>
              </li>
              <li class="nav-item">
                <a @click="changeTab(5)" class="nav-link" id="suspended-tab" data-toggle="tab" href="#suspended" role="tab" aria-controls="suspended">Suspended Outages</a>
              </li>
              <li class="nav-item">
                <a @click="openDomainExpiry()" class="nav-link" id="domain_expiration-tab" data-toggle="tab" href="#domain_expiration" role="tab" aria-controls="domain_expiration">Domain Expiration</a>
              </li>
              <li class="nav-item">
                <a @click="changeTab(2)" class="nav-link" id="settings-tab" data-toggle="tab" href="#test-tab" role="tab" aria-controls="test-tab">Test Settings</a>
              </li>
              <li class="nav-item">
                <a @click="changeTab(3)" class="nav-link" id="racks-tab" data-toggle="tab" href="#racks" role="tab" aria-controls="down">Racks</a>
              </li>
              <li class="nav-item">
                <a @click="changeTab(4)" class="nav-link" id="nodes-tab" data-toggle="tab" href="#nodes" role="tab" aria-controls="test-tab">Nodes</a>
              </li>

            </ul>
          </div>
          <!--          <div v-if="this.currentOpenTab!==3">-->
          <div v-if="currentOpenTab !== 2 && this.currentOpenTab!==3 &&  this.currentOpenTab!==4&&  this.currentOpenTab!==5" class="col-md-3">
            <input  v-model="globalSearchQuery" type="text"  class="form-control m-t-1" :placeholder="(currentOpenTab === 0) ? 'Search in current outages' : 'Search'" />
          </div>
<!--          <div v-if="currentOpenTab!==2" class="col-md-1 text-right">-->
<!--            <button class="btn btn-primary m-t-1" data-toggle="modal" data-target="#outageMacrosModal">Preset Replies</button>-->
<!--          </div>-->
          <div v-if="currentOpenTab===2" class="col-md-3 align-bottom">
            <button class="btn btn-primary btn-block m-t-1" @click="addNewSetting"> <i class="fa fa-plus"></i> Add New Setting</button>
            <button class="btn btn-primary btn-block m-t-1" @click="addStatus"> <i class="fa fa-plus"></i> Add Status</button>
          </div>

          <!--          </div>-->

        </div>
      </div>
      <div class="card-body pb-0">
        <div class="tab-content customer-table">
          <div id="racks" class="tab-pane fade">
            <racks v-if="currentOpenTab === 3" ref="allRacks"/>
          </div>
          <div id="nodes"  class="tab-pane fade">
            <nodes v-if="currentOpenTab === 4" ref="allNodes"/>
          </div>
          <div id="up" class="tab-pane fade ">
            <better-uptime-table :ticketLoading="ticketLoading" :presetMacros="presetMacros" ref="downTable" tableType="Current" datatableId="currentOutages" status="Down" :searchQuery="globalSearchQuery.toLowerCase().trim()"/>
          </div>
          <div id="upZabbix" class="tab-pane active show">
            <better-uptime-table :ticketLoading="ticketLoading" :presetMacros="presetMacros" ref="downZabbixTable" tableType="Current" datatableId="currentZabbixOutages" status="Down" :searchQuery="globalSearchQuery.toLowerCase().trim()"/>
          </div>
          <div id="down" class="tab-pane fade">
            <better-uptime-table :ticketLoading="ticketLoading" :presetMacros="presetMacros" ref="upTable" tableType="Recent" datatableId="recentOutages" status="Up" :searchQuery="globalSearchQuery.toLowerCase().trim()"/>
          </div>
          <div id="suspended" class="tab-pane fade">
            <better-uptime-table :presetMacros="presetMacros" ref="downTable1" tableType="suspended" datatableId="suspendedOutages" status="Down" :searchQuery="globalSearchQuery.toLowerCase().trim()"/>
          </div>
          <div id="test-tab" class="tab-pane fade">
            <form @submit.prevent="saveSettings">
              <div v-for="(selectedSetting, index) in selectedStatusSettings.settings" class="row mb-3">
                <div class="col-md-4">
                  <label>Choose Status</label>
                  <select v-model="selectedSetting.status" class="form-control">
                    <template v-for="(row) in testStatusList">
                      <option v-if="row.status.toLowerCase() !== 'active'" :value="row.status">{{ row.status }}</option>
                    </template>
                  </select>
                </div>
                <div class="col-md-4">
                  <label>Select Setting</label>
                  <select v-model="selectedSetting.setting" class="form-control">
                    <option v-for="setting in statusSettings" :value="setting">{{ setting }}</option>
                  </select>
                </div>
                <div v-if="selectedSetting.setting" class="col-md-3">
                  <label>Duration</label>
                  <div style="display: flex">
                    <select style="width: 100%" class="custom-select form-control form-control-sm datatable-dropdown" id="grouped"  aria-describedby="grouped" required v-model="selectedSetting.duration">
                      <option value="minutes" >Minutes</option>
                      <option value="hours" >Hours</option>
                      <option value="days" >Days</option>
                    </select>
                    <input v-model="selectedSetting.value" :min="selectedSetting.duration === 'minutes' ? 5 : ''" type="number" class="form-control ml-2"/>
                  </div>
                </div>
                <div v-if="index > 0" class="col-md-1 align-bottom">
                  <button class="btn btn-danger btn-sm" @click="removeSetting(index)"><i class="fa fa-times"></i></button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button class="btn btn-primary pull-right" type="submit">Save Changes</button>
                  <br>
                  <small class="pull-left">Last Updated By <b>{{ selectedStatusSettings.meta.updatedBy }}</b> at <b>{{ selectedStatusSettings.meta.updatedAt | formatDate }}</b></small>
                </div>
              </div>
            </form>
          </div>
          <div id="domain_expiration" class="tab-pane fade">
            <domain-expiry @open-modal="loadModal()" ref="domainExpiry"/>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_body">
      <div class="modal" tabindex="-1" role="dialog" id="viewEventsModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">
                Test ID: <code>{{selectedItemForView.id}}</code>
              </h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h6>Test Name:
                <code>{{selectedItemForView.name }}</code>
              </h6>
              <br>
              <h6>
                Previous Events
                <code v-if="selectedItemForView.status === 'Up'" class="pull-right">Total Downtime: {{totalDownDurationOfSelectedItem}}</code>
              </h6>
              <code>
                <perfect-scrollbar class="scroll-area-modal">
                 <table class="table eventsTable">
                  <thead>
                  <tr>
                    <th class="text-center">Start</th>
                    <th class="text-center">End</th>
                    <th class="text-center">Time Duration</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Acknowledged By</th>
<!--                    <th class="text-center">Status Code</th>-->
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(event, index) in events" :key="'event_' + index">
                    <td class="text-center">{{event.start | formatDate}}</td>
                    <td class="text-center" v-if="event.end">{{event.end | formatDate}}</td>
                    <td class="text-center" v-else>Current</td>
                    <td class="text-center" v-if="event.end !== undefined">{{timeDifferenceBetweenGivenDates(event.end, event.start)}}</td>
                    <td class="text-center" v-else>-</td>
                    <td class="text-center">{{event.status}}</td>
                    <td class="text-center">{{event.acknowledgedBy || ''}}</td>
<!--                    <td class="text-center">{{event.status=='up' ? 200 : 500}}</td>-->
                  </tr>
                  </tbody>
                </table>
                </perfect-scrollbar>
                <div class="row mt-2" v-if="events.length > 0 ">
                  <div class="col-md-12 d-flex justify-content-between">
                    <span class="lh-3 pull-left">
                        Page {{this.pageNumber + 1}} of {{pageCount}}
                    </span>
                    <section v-if="!eventsShowAll" class="dataTables_paginate paging_full_numbers">
                      <paginate
                          :pageCount="pageCount"
                          :clickHandler="goToPage"
                          :prevText="'Prev'"
                          :nextText="'Next'"
                          page-class="page-item new"
                          id="events"
                          prev-class="page-item"
                          prev-link-class="page-link"
                          next-class="page-item"
                          next-link-class="page-link"
                          page-link-class="page-link"
                          containerClass="pagination">
                      </paginate>
                    </section>
                    <a v-if="!eventsShowAll" @click="setPagination('incidents')" href="javascript:void(0)">Show all</a>
                    <a v-if="eventsShowAll" @click="showLessPagination('incidents')" href="javascript:void(0)">Show less</a>
                  </div>
                </div>
              </code>
              <section class="mt-5" v-if="selectedItemForView.notes !== undefined">
                <h6>Test & Notes History</h6>
                <code>
                  <perfect-scrollbar class="scroll-area-modal">
                    <table class="table notesTable">
                      <thead>
                      <tr>
                        <th class="text-center">Detail</th>
                        <th class="text-center">Added On</th>
                        <th class="text-center">Added By</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(note, index) in notes" :key="'note_' + index">
                        <td class="text-center">{{note.note}}</td>
                        <td class="text-center">{{note.noteDate | formatDate}}</td>
                        <td class="text-center">{{note.noteAddedBy ? note.noteAddedBy : ''}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </perfect-scrollbar>
                  <div class="row mt-2" v-if="notes.length > 0 ">
                    <div class="col-md-12 d-flex justify-content-between">
                    <span class="lh-3 pull-left">
                        Page {{this.notesPageNumber + 1}} of {{notesPageCount}}
                    </span>
                      <section v-if="!notesShowAll" class="dataTables_paginate paging_full_numbers">
                        <paginate
                            id="notes"
                            :pageCount="notesPageCount"
                            :clickHandler="goToNotesPage"
                            :prevText="'Prev'"
                            :nextText="'Next'"
                            page-class="page-item"
                            prev-class="page-item"
                            prev-link-class="page-link"
                            next-class="page-item"
                            next-link-class="page-link"
                            page-link-class="page-link"
                            containerClass="pagination">
                        </paginate>
                      </section>
                      <a v-if="!notesShowAll" @click="setPagination('notes')" href="javascript:void(0)">Show all</a>
                      <a v-if="notesShowAll" @click="showLessPagination('notes')" href="javascript:void(0)">Show less</a>
                    </div>
                  </div>
                </code>
              </section>
              <section class="mt-5" v-if="selectedItemForView.domainExpiryIncidents && selectedItemForView.domainExpiryIncidents.length">
                <h6>Domain Expiry Events</h6>
                <code>
                  <perfect-scrollbar style="position: relative; max-height: 170px">
                    <table class="table notesTable">
                      <thead>
                      <tr>
                        <th class="text-center">Domain Expiration Days</th>
                        <th class="text-center">Started On</th>
                        <th class="text-center">Resolved At</th>
                      </tr>
                      </thead>
                        <tbody>
                        <tr v-for="(row, index) in filteredDomainExpiryIncidents" :key="'note_' + index">
                          <td class="text-center">{{row.domain_expiration_time_left}}</td>
                          <td class="text-center">{{row.startedAt | formatDate}}</td>
                          <td class="text-center">
                            <span v-if="row.resolvedAt">{{row.resolvedAt | formatDate}}</span>
                          </td>
                        </tr>
                        </tbody>
                    </table>
                  </perfect-scrollbar>

                </code>
              </section>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal" tabindex="-1" role="dialog" id="addTicketModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">ADD TICKET URL</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Ticket URL</label>
                <textarea class="form-control" v-model="selectedItemForView.ticket_url"></textarea>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
              <button class="btn btn-outline-info btn-sm" :disabled="action"  @click="addTicket()">
                <div class="loader mini_loader" v-if="selectedItemForView && action === 'addTicket'"></div>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal" tabindex="-1" role="dialog" id="addNoteModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Test Name: {{selectedItemForView.name}}</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Add note</label>
                <textarea class="form-control" v-model="selectedItemForView.note"></textarea>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
              <button class="btn btn-outline-info btn-sm" :disabled="action"  @click="addNote()">
                <div class="loader mini_loader" v-if="selectedItemForView && action === 'addNote'"></div>
                Add Note
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal" tabindex="-1" role="dialog" id="changeLiveStatusModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Test Name: {{selectedItemForView.name}}</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="liveStatusDropDown">Update Live Status</label>
                <select style="padding-top: 5px;padding-bottom: 5px" class="form-control" v-model="selectedItemForView.status" id="liveStatusDropDown">
                  <option value="up">Up</option>
                  <option value="down">Down</option>
                </select>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
              <button class="btn btn-outline-info btn-sm" :disabled="action"  @click="updateLiveStatus()">
                <div class="loader mini_loader" v-if="selectedItemForView && action === 'updateLiveStatus'"></div>
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal" tabindex="-1" role="dialog" id="addStatusModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Add New Status</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="saveStatus">
              <div class="modal-body">
                <div class="form-group">
                  <label for="liveStatusDropDown">Status Name</label>
                  <input v-model="status" required type="text" class="form-control m-t-1" />
                </div>
                <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
                <button class="btn btn-outline-info btn-sm" type="submit" :disabled="action === 'addStatus'">
                  <div class="loader mini_loader" v-if="action === 'addStatus'"></div>
                  Save
                </button>
                <div class="row">
                  <div class="col-md-10">
                    <b>Status</b>
                  </div>
                  <div class="col-md-2">
                    <b>Action</b>
                  </div>
                </div>
                <perfect-scrollbar class="scroll-area">
                  <div v-for="(row, index) in testStatusList" :key="index" class="row border-bottom mt-3">
                    <div class="col-md-10">
                      <span>{{ row.status }}</span>
                    </div>

                    <div class="col-md-2 text-center">
                      <span @click="deleteStatus(row)" class="details-control shown"></span>

                    </div>
                    <hr>
                  </div>
                </perfect-scrollbar>
              </div>
<!--              <div class="modal-footer">-->
<!--                <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>-->
<!--                <button class="btn btn-outline-info btn-sm" type="submit" :disabled="action === 'addStatus'">-->
<!--                  <div class="loader mini_loader" v-if="action === 'addStatus'"></div>-->
<!--                  Save-->
<!--                </button>-->
<!--              </div>-->
            </form>


          </div>
        </div>
      </div>
      <div class="modal" tabindex="-1" role="dialog" id="generateReport" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title text-center">Generate Report for Monitors</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="saveStatus">
              <div class="modal-body">
                <label class="fw-600">Select fields:</label>
                <div class="d-flex">
                  <div v-for="(field, index) in fields" :key="index" class="custom-control custom-checkbox mr-30">
                    <input :disabled="field === 'Rack' || field === 'IP' || field === 'Domain'" type="checkbox"  class="custom-control-input mr-10" :id="field" :value="field" v-model="selectedFields"/>
                    <label class="custom-control-label pt-4 mb-0" :for="field">{{ field }}</label>
                  </div>
                </div>
                <template v-if="selectedFields.includes('Plan')" >
                  <label class="fw-600 mt-10">Select plans:</label>
                  <div class="d-flex">
                    <div v-for="(field, index) in plans" :key="index+ 'plan'" class="custom-control custom-checkbox mr-20">
                      <input type="checkbox"  class="custom-control-input mr-10" :id="field.value" :value="field" v-model="selectedPlanFields"/>
                      <label class="custom-control-label pt-4 mb-0" :for="field.value">{{ field.name }}</label>
                    </div>
                  </div>
                </template>
                <label class="fw-600 mt-10">Select status:</label>
                <div class="d-flex">
                  <div v-for="(field, index) in statusList" :key="index+ 'status'" class="form-check-radio mr-30">
                    <label class="form-check-label">
                      <input :id="field" :value="field" class="form-check-input" v-model="selectedStatus" type="radio" :name="field">
                      {{ field }}
                      <span class="form-check-sign"></span>
                    </label>
                  </div>
                </div>
                <hr>
                <div class="text-right mb-10">
                  <button @click="generateReport()"  class="btn btn-outline-primary btn-sm" type="submit" :disabled="reportLoading">
                    <div v-if="reportLoading" class="loader mini_loader"></div>
                    Generate
                  </button>
                </div>
                <perfect-scrollbar class="scroll-area-modal">
                  <table class="table table-striped table-bordered">
                    <thead>
                    <tr>
                      <th class="text-center">Created By
                      </th>
                      <th class="text-center">Created At</th>
                      <th class="text-center">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in sortPrevReports" :key="index">
                      <td class="text-center">{{ row.createdBy }}</td>
                      <td class="text-center">
                        {{formattedDate(row.createdAt)}}
                      </td>
                      <td class="text-center">
                        <div>
                          <button v-if="row.reportLoading" class="btn btn-primary btn-sm ml-2"><i class="fa fa-spinner fa-spin"></i></button>
                          <button v-else-if="row.url" @click="download(row.url)" class="btn btn-primary btn-sm ml-2"><i class="fa fa-download"></i></button>
                        </div>

                      </td>
                    </tr>
                    </tbody>
                  </table>
                </perfect-scrollbar>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
              </div>
            </form>


          </div>
        </div>
      </div>
    </div>
    <preset-outages-modal :presetMacros="presetMacros" />
    <ticket-modal @changeLoading="changeLoading" ref="ticketModal"/>
    <nodes-modal ref="nodes"/>
    <racks-modal ref="racks"/>
    <affected-nodes-and-racks ref="nodes"/>
    <temp-domain-modal ref="tempDomainModal" />
  </div>
</template>

<script>
import multiSelect from "vue-multiselect";
import BetterUptimeTable from "../../../components/Admin/Dashboard/BetterUptimeTable";
import moment from "moment";
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import dateMixin from '../../../mixins/dateMixin';
import refreshToken from "../../../mixins/refreshTokenMixin";
import momentDurationFormatSetup from "moment-duration-format";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import racks from "../../../components/Admin/Dashboard/racks";
import nodes from "../../../components/Admin/Dashboard/nodes";
import domainExpiry from "../../../components/Admin/Dashboard/domainExpiryIncidents.vue";
import Paginate from 'vuejs-paginate'
import tempDomainModal from "@/components/Admin/Tasks/showTempDomainModal.vue";

momentDurationFormatSetup(moment);


export default {
  name: "index",
  components: {
    multiSelect,
    affectedNodesAndRacks: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/Dashboard/affectedNodesAndRacks"),
    tempDomainModal, BetterUptimeTable, presetOutagesModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/presetOutagesModal"
            ),
    ticketModal: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/Tasks/betteruptimeTicketModal"), PerfectScrollbar,  racks,
    nodesModal: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/Dashboard/nodesModal"),
    racksModal: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/Dashboard/racksModal"),
    nodes, Paginate, domainExpiry},
  mixins: [refreshToken, dateMixin],

  data(){
    return {
      showPlans: false,
      savePlansLoading: false,
      selectedPlansForMonitorAlerts: [],
      allPlans: ['Starter', 'Professional', 'VPS', 'Business', 'Enterprise', 'Dedicated', 'Managed WordPress', 'Journey', 'Mediavine Plan 1', 'Mediavine Plan 2', 'Mediavine Plan 3', 'Mediavine Enterprise', 'North Commerce Starter'],
      ticketLoading: {flag: false, id: null},
      reportLoading: false,
      modalOpenedFrom: null,
      status: null,
      testsOff: [],
      zabbixTestsOff: [],
      testsOn: [],
      presetMacros: [],
      loading: false,
      downListener: null,
      zabbixDownListener: null,
      upListener: null,
      searchQuery: '',
      currentOpenTab: 6,
      globalSearchQuery: '',
      action: null,
      fields: ["Domain", "IP", "Rack", "Node", "Unit", "Plan", "Email"],
      statusList: ['Down', 'Suspended'],
      plans: [{name:'Starter', value: 'WPO Starter'},{name:'Professional', value: 'WPO Professional'},{name:'Business', value: 'WPO Business'},{name:'Enterprise', value: 'WPO Enterprise'},{name:'VPS', value: 'WPO VPS'},{name:'Dedicated', value: 'WPO Dedicated'}],
      selectedFields: ['Domain', 'IP', 'Rack'],
      selectedStatus: 'Down',
      previousReports: [],
      selectedPlanFields: [{name:'Starter', value: 'WPO Starter'},{name:'Professional', value: 'WPO Professional'},{name:'Business', value: 'WPO Business'},{name:'Enterprise', value: 'WPO Enterprise'},{name:'VPS', value: 'WPO VPS'},{name:'Dedicated', value: 'WPO Dedicated'}],
      totalDownDurationOfSelectedItem: '',
      selectedItemForView: {},
      pageSize: 5,
      pageNumber: 0,
      notesPageSize: 5,
      notesPageNumber: 0,
      eventsShowAll: false,
      notesShowAll: false,
      selectedStatusSettings: {
        meta: {},
        settings:[
          {
            status: '',
            setting: '',
            value: ''
          }
        ]
      },
      testStatusList: [],
      // testStatusList: [
      //   'Moved',
      //   'Suspended',
      //   'Domain Expired',
      //   'Other'
      // ],
      statusSettings: ['expiry'],
      opBtnLoading: false,
      refreshTagLoader: false

    }
  },
  updated() {
    if(this.currentOpenTab === 6) {
      this.loadOutages('zabbix');
    }
  },
  mounted(){
    $('[data-toggle="tooltip"], [rel="tooltip"]').tooltip();

    db.collection('permissions').doc('betteruptime-monitor-settings').get().then(settings => {
      if(settings.exists) {
        this.selectedStatusSettings = settings.data();
      }
    });
    this.getStatuses()
    this.loadOutages('up');
    this.loadOutages('zabbix');
    this.selectedPlansForMonitorAlerts = this.user.selectedPlansForMonitorAlert
    // this.loadOutages('down')
    /* eslint-disable */
    $(document).ready(function () {
      $(".datatable").DataTable({
        pagingType: "full_numbers",
        lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
        responsive: true,
        retrieve: true,
        order: [[0, "desc"]],
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search records"
        }
      });
    });
    const modalSelector = $('#viewEventsModal');
    // modalSelector.on('show.bs.modal', function () {
    //   setTimeout(() => {
    //     $(".eventsTable").DataTable({
    //       pageLength:5, ordering: false,
    //       destroy: true, lengthChange: false,
    //       searching: false, deferRender: true,
    //       retrieve: true
    //     });
    //     $(".notesTable").DataTable({
    //       pageLength:5, ordering: false,
    //       destroy: true, lengthChange: false,
    //       searching: false, deferRender: true,
    //       retrieve: true
    //     });
    //   }, 100);
    // });
    modalSelector.on('hidden.bs.modal', () => {
      this.selectedItemForView = {};
      // $(".eventsTable").DataTable().destroy();
      // $(".notesTable").DataTable().destroy();
    });
    /* eslint-enable */
    this.getPresetReplies()
  },

  computed: {
    zabbixMonitors() {
      return this.zabbixTestsOff;
    },
    sortPrevReports(){
      return this.previousReports.sort((a,b)=> new Date(b.createdAt) - new Date (a.createdAt)).splice(0,20)
    },
    filteredDomainExpiryIncidents() {
      return this.selectedItemForView.domainExpiryIncidents.sort((a,b)=> new Date(b.startedAt) - new Date (a.startedAt))
    },
    events() {
      const start = this.pageNumber * this.pageSize, end = start + this.pageSize;
      return this.selectedItemForView && this.selectedItemForView.incidents && this.selectedItemForView.incidents.length > 0 ?  this.selectedItemForView.incidents.slice(start, end) : [];
    },
    notes() {
      const start = this.notesPageNumber * this.notesPageSize, end = start + this.notesPageSize;
      return this.selectedItemForView && this.selectedItemForView.notes && this.selectedItemForView.notes.length > 0 ?  this.selectedItemForView.notes.slice(start, end) : [];
    },
    pageCount(){
      if(this.selectedItemForView && this.selectedItemForView.incidents && this.selectedItemForView.incidents.length > 0) {
        let filteredGroups = this.selectedItemForView.incidents
        let l = filteredGroups.length, s = this.pageSize;
        return Math.ceil(l/s);
      }
    },
    notesPageCount(){
      if(this.selectedItemForView && this.selectedItemForView.notes && this.selectedItemForView.notes.length > 0) {
        let filteredGroups = this.selectedItemForView.notes
        let l = filteredGroups.length, s = this.notesPageSize;
        return Math.ceil(l/s);
      }
    },
    muteNotiFlag() {
      return this.$store.getters.muteNotiFlag;
    },
    user() {
      return this.$store.getters.user;
    },
    isNotifications() {
      return this.$store.getters.isNotifications;
    },
  },
  beforeDestroy(){
    this.destroyListeners();
  },
  watch: {
    currentOpenTab(val) {
      if(val === 6) {
        this.$refs.downZabbixTable.groupTestsInAPlan(this.zabbixMonitors)
      } else if(val === 5) {
        this.$refs.downTable1.groupTestsInAPlan(this.zabbixMonitors)
      } else if(val === 1) {
        this.$refs.upTable.groupTestsInAPlan(this.testsOn)
      }
    },
    globalSearchQuery (newValue) {
      this.globalSearchQuery = newValue.replace(/\s/g, '');
    }

  },
  methods: {
    async saveSelectedPlans() {
      this.savePlansLoading = true
      await this.$store.commit('mutateSelectedPlansForMonitorAlerts', this.selectedPlansForMonitorAlerts)
      await db.collection('users').doc(this.user.uid).update({ selectedPlansForMonitorAlert: this.selectedPlansForMonitorAlerts})
      this.showToast({message: 'You have successfully saved selected plans for monitor alerts.' , duration: 4000}, true, 'info')
      this.savePlansLoading = false

    },
    changeLoading(val) {
      console.log('hellooooooooooooooo', val)
      this.ticketLoading = val
      console.log(`this ${this.ticketLoading}`)
    },
    download (url) {
      window.open(url, '_self');
    },
    async generateReport() {
      this.reportLoading = true
      const plans = this.selectedPlanFields.map(el => {
        return el.value
      })
      const response = await this.$patchStackService.post('scripts/monitor', {
        grant_type: 'token',
        plans,
        fields: this.selectedFields,
        status: this.selectedStatus.toLowerCase(),
        createdBy: `${this.user.firstName} ${this.user.lastName}`
      }, { headers: {
            'Authorization': '1a18fefe16e4ab6ae1967a2ad980f396'
            }});
      await this.getPrevReports()
      this.reportLoading = false

    },
    loadModal(id) {
      $("#" + id).modal("show");
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    openDomainExpiry() {
      this.currentOpenTab = 6
      this.$refs.domainExpiry.load()
    },
    goToPage(pageNum) {
      this.pageNumber = pageNum-1;
    },
    goToNotesPage(pageNum) {
      this.notesPageNumber = pageNum-1;
    },
    setPagination(type){
      if(type === 'incidents') {
        this.eventsShowAll = true
        this.pageNumber = 0
        this.pageSize = this.selectedItemForView.incidents.length
      } else if(type === 'notes') {
        this.notesShowAll = true
        this.notesPageNumber = 0
        this.notesPageSize = this.selectedItemForView.notes.length
        // this will active first page
        // $("ul#notes li:nth-child(2)").addClass('active');
      }
    },
    showLessPagination(type){
      if(type === 'incidents') {
        this.eventsShowAll = false
        this.pageNumber = 0
        this.pageSize = 5

      } else if(type === 'notes') {
        this.notesShowAll = false
        this.notesPageNumber = 0
        this.notesPageSize = 5
      }
    },
    async toggleMute(value){
      await this.$store.commit('muteNotiMutate', value);
      await db.collection('users').doc(this.user.uid).update({
        muteNotiFlag: value
      });
    },
    updateIsNotificationsForUser(){
      if(this.isNotifications){
        this.$store.commit('notificationMutate', false);
        this.$store.dispatch('notification/resetAdminListens');
        this.$store.commit('notification/removeOutages');
        db.collection('users').doc(this.user.uid).get().then(doc => {
          const token = doc.data()['fcmToken'];
          // this.$http.post('/status_cake/un_subscribe_from_topic', {
          //   fcmToken: token
          // }).then((resp) => {
          //   console.log(resp.data.msg);
          // });
        });
      }else{
        this.$store.commit('notificationMutate', true);
        this.$store.commit('updateAdminNotificationOnLogin', {type: 'Down', status: true}, {root:true});
        this.$store.commit('updateAdminNotificationOnLogin', {type: 'Up', status: true}, {root:true});
        this.$store.dispatch('notification/adminNotifications');
        db.collection('users').doc(this.user.uid).get().then(doc => {
          const token = doc.data()['fcmToken'];
          // this.$http.post('/status_cake/subscribe_to_topic', {
          //   fcmToken: token
          // }).then((resp) => {
          //   console.log(resp.data.msg);
          // });
        });
      }
      db.collection('users').doc(this.user.uid).update({
        notifications: this.isNotifications
      });

    },
    getStatuses(){
      db.collection('permissions').doc('betteruptime-monitor-status').get().then(ref => {
        if(ref.exists) {
          this.testStatusList = ref.data().statusArray;
        }
      });
    },
    async deleteStatus(data) {
      try{
        console.log(data)
        let ref=await db.collection('permissions').doc('betteruptime-monitor-status').get()
        if(ref.exists) {
          const {statusArray} = ref.data();
          let index=statusArray.findIndex(el => el.status === data.status)
          statusArray.splice(index, 1)
          await db.collection('permissions').doc('betteruptime-monitor-status').update({statusArray})
        }
        await this.getStatuses()
        $('#addStatusModal').modal('hide')
        swal('Success!', 'Status has been deleted successfully', 'success');
      }catch (e) {
        $('#addStatusModal').modal('hide')
        swal('Error!', 'Some thing went wrong while deleting status', 'error');
      }

    },
    syncMonitors(){
      this.opBtnLoading = true;
      this.$http.post('/monitor/sync', {grant_type: 'token'}).then(resp => {
        swal('Synchronized!', resp.data.msg, 'success');
        this.addLog({
          primaryPlan: 'Account Based Operation',
          message: 'User has synchronized monitors',
          level: "info"
        })
      }).catch(e => {
        console.error(e);
        swal('Error!', 'Some thing went wrong! Please check logs', 'error');
      }).finally(() => {
        this.opBtnLoading = false;
      })
    },
    async getPrevReports(){
      const report2 = await db.collection('savedReports').where('key', '==', 'Monitors').get();
      const {downloadUrls} = report2.docs[0].data() || [];
      this.previousReports = downloadUrls;
    },
    async openModalForGeneratingReport() {
      // await this.getStatusList()
      await this.getPrevReports()
      $("#generateReport").modal("show");
    },
    syncMonitorTags(){
      this.refreshTagLoader = true;
      this.$http.post('/monitor/sync-monitor-tags', {grant_type: 'token'}).then(resp => {
        swal('Synchronized!', resp.data.msg, 'success');
        this.addLog({
          primaryPlan: 'Account Based Operation',
          message: 'You have successfully synchronized monitor tags!',
          level: "info"
        })
      }).catch(e => {
        console.error(e);
        swal('Error!', 'Something went wrong while synchronizing tags!', 'error');
      }).finally(() => {
        this.refreshTagLoader = false;
      })
    },
    saveSettings () {
      this.selectedStatusSettings.meta = {
        updatedBy: this.user.firstName + ' ' + this.user.lastName,
        updatedAt: new Date().toISOString()
      };
      db.collection('permissions').doc('betteruptime-monitor-settings').set(this.selectedStatusSettings).then(() => {
        swal('Success!', 'Settings has been saved', 'success');
      })
      this.addLog({
        primaryPlan: 'Account Based Operation',
        message: 'Setting has been saved.',
        level: "info"
      })
    },
    removeSetting (index) {
      this.selectedStatusSettings.settings.splice(index, 1);
    },
    addStatus(){
      this.status=''
      this.action=''
      $("#addStatusModal").modal("show");
    },
    async saveStatus(){
      try{
        if (!this.status) {
          return
        }
        this.action='addStatus'
        this.testStatusList.push({status: this.status})
        await db.collection('permissions').doc('betteruptime-monitor-status').set({statusArray: this.testStatusList})

        this.action=''
        $('#addStatusModal').modal('hide')
        swal('Success', 'You have successfully added status', 'success');

      }catch (e) {
        this.action=''
        $('#addStatusModal').modal('hide')
        swal('Error', 'Something went wrong while adding status', 'error');
      }
    },
    addNewSetting(){
      this.selectedStatusSettings.settings.push({
        status: '',
        setting: '',
        value: ''
      })
    },
    async getPresetReplies(){
      this.presetMacros=[]
      let result=await db.collection("permissions")
          .doc("preset_macros_outages")
          .get();
      if(result.exists){
        this.presetMacros = result.data().replies;
      }
    },
    searchOutages(){
      console.log('in search', this.globalSearchQuery, this.currentOpenTab)
      if (this.currentOpenTab === 0) {
        this.searchQuery=this.globalSearchQuery
        this.$refs.downTable.searchQuery = this.gloablSearchQuery;
        console.log('search value',  this.$refs.downTable.searchQuery)
      } else {
        this.searchQuery=this.globalSearchQuery
        this.$refs.upTable.searchQuery = this.gloablSearchQuery;

      }
    },
    destroyListeners(){
      console.log('Before destroying, release all listeners...');
      // if(this.upListener){
      //   this.upListener();
      // }
      // if(this.downListener){
      //   this.downListener();
      // }
      if(this.zabbixDownListener) {
        this.zabbixDownListener()
      }
    },
    updateLiveStatus(){
      this.action = 'updateLiveStatus';
      console.log('updating live status in: ' + this.selectedItemForView.id);
      this.selectedItemForView.incidents[this.selectedItemForView.incidents.length - 1].end = new Date().toISOString();
      this.selectedItemForView.incidents.push({
        start: new Date().toISOString(),
        status: this.selectedItemForView.status,
        statusCode: (this.selectedItemForView.status === 'up') ? 200 : 0,
        from: 'updateLiveStatus',
      });
      this.selectedItemForView.updatedAt = new Date().toISOString();
      if (this.selectedItemForView.status === 'down') {
        this.selectedItemForView.downCount += 1;
      }
      db.collection('monitors').doc(this.selectedItemForView.id.toString())
          .update(this.selectedItemForView)
          .then(()=>{
            /* eslint-disable */
            $("#changeLiveStatusModal").modal("hide");
            /* eslint-enable */
            swal('Success', 'Status has been successfully updated', 'success');
          }).catch(() => {
        swal('Error', 'Error in updating status', 'error');
      }).finally(() => {
        this.selectedItemForView = {};
        this.action = null
      });
    },
    addNote(){
      this.action = 'addNote';
      console.log('Adding note in: ',this.selectedItemForView);
      if(this.selectedItemForView.notes === undefined){
        this.selectedItemForView.notes = [];
      }
      this.selectedItemForView.noteAddedBy= this.user.firstName + ' ' + this.user.lastName
      this.selectedItemForView.noteAddedAt= new Date().toISOString()
      this.selectedItemForView.notes.push({
        noteDate: new Date().toISOString(),
        note: this.selectedItemForView.note,
        noteAddedBy: this.user.firstName + ' ' + this.user.lastName
      });
      if(this.selectedItemForView.type === 'zabbix') {
        db.collection('zabbixMonitors').doc(this.selectedItemForView.id.toString())
            .update(this.selectedItemForView)
            .then(()=>{
              /* eslint-disable */
              $("#addNoteModal").modal("hide");
              /* eslint-enable */
              swal('Success', 'Note has been successfully added', 'success');
            }).catch(() => {
          swal('Error', 'Error in adding note!', 'error');
        }).finally(() => {
          this.selectedItemForView = {};
          this.action = null
        });
      } else {
        db.collection('monitors').doc(this.selectedItemForView.id.toString())
            .update(this.selectedItemForView)
            .then(()=>{
              /* eslint-disable */
              $("#addNoteModal").modal("hide");
              /* eslint-enable */
              swal('Success', 'Note has been successfully added', 'success');
            }).catch(() => {
          swal('Error', 'Error in adding note!', 'error');
        }).finally(() => {
          this.selectedItemForView = {};
          this.action = null
        });
      }

    },
    addTicket() {
      this.action = 'addTicket';
      console.log('Adding ticket in: ' + this.selectedItemForView.id);
      db.collection('zabbixMonitors').doc(this.selectedItemForView.id.toString())
          .update(this.selectedItemForView)
          .then(()=>{
            /* eslint-disable */
            $("#addTicketModal").modal("hide");
            /* eslint-enable */
            swal('Success', 'Ticket has been successfully added', 'success');
          }).catch(() => {
        swal('Error', 'Error in adding ticket url!', 'error');
      }).finally(() => {
        this.selectedItemForView = {};
        this.action = null
      });
    },
    changeTab(tabIndex) {
      this.currentOpenTab = tabIndex;
      if (this.currentOpenTab === 0) {
        this.$refs.downTable.searchQuery = '';
        this.$refs.downTable.notInWPOFilter = true;
        this.$refs.upTable.notInWPOFilter = true;
        this.$refs.downTable.selectedFilters = this.$refs.downTable.filteredOptions;
        this.$refs.upTable.selectedFilters = [];
        this.globalSearchQuery = '';
      } else if(this.currentOpenTab === 1) {
        this.globalSearchQuery = ''
      } else if (this.currentOpenTab === 2) {
        console.log(tabIndex);
        this.$refs.upTable.searchQuery = '';
        this.$refs.upTable.notInWPOFilter = true;
        this.$refs.downTable.notInWPOFilter = true;
        this.$refs.downTable.selectedFilters = [];
        this.$refs.upTable.selectedFilters = this.$refs.upTable.filteredOptions;
        this.globalSearchQuery = '';
      }
    },
    loadOutages (status) {
      this.loading = false;
      let upQuery = null;
      let downQuery = null;
      if(status === 'up') {
        this.testsOn = [];
        const fiveMinutesAgo = moment(new Date()).subtract(5, 'minutes').toISOString();
      // .where('updatedAt', '>=', moment(new Date()).subtract(1, 'days').toISOString())
        upQuery = db.collection('zabbixMonitors')
            .where('status', '==', 'up')
            .orderBy("updatedAt", "desc")
            .limit(50)
            .get()
            .then(snapshot => {

              snapshot.forEach(doc => {
                this.testsOn.push({ ...doc.data(), id: doc.id });
              });

              if (this.$refs.upTable) {
                this.$refs.upTable.groupTestsInAPlan(this.testsOn);
              }
            });
        // this.upListener = upQuery.onSnapshot(querySnapshot => {
        //   querySnapshot.docChanges().forEach(change => {
        //     switch (change.type) {
        //       case 'added':
        //         this.testsOn = this.testsOn.filter(test => test.id !== change.doc.id);
        //         this.testsOn.unshift({id: change.doc.id , ...change.doc.data()});
        //         break;
        //       case "modified":
        //       {
        //         const modifiedData = change.doc.data();
        //         let tIndex = this.testsOn.findIndex(test => test.id === change.doc.id);
        //         this.testsOn[tIndex] = {...modifiedData}
        //       }
        //         break;
        //       case "removed":
        //       {
        //         const removedData = change.doc.data();
        //         this.testsOn = this.testsOn.filter(test => test.id !== removedData.id);
        //       }
        //         break;
        //     }
        //   });
        //   console.log(this.testsOn);
        //   if(this.$refs.upTable) {
        //     this.$refs.upTable.groupTestsInAPlan(this.testsOn);
        //   }
        // });
      } else if(status === 'zabbix') {
        this.zabbixTestsOff = [];
        const zabbixQuery = db.collection('zabbixMonitors')
            .where('status', 'in', ['down', 'paused', 'pending'])
            // .orderBy("updatedAt", "desc")
            // .limit(500);
        this.downListener = zabbixQuery.onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            switch (change.type) {
              case 'added':
                this.zabbixTestsOff = this.zabbixTestsOff.filter(test => test.id !== change.doc.id);
                this.zabbixTestsOff.unshift({id: change.doc.id , ...change.doc.data()});
                break;
              case "modified":
              {
                console.log('modifiedat 115')
                const modifiedData = change.doc.data();
                let tIndex = this.zabbixTestsOff.findIndex(test => test.id === change.doc.id);
                this.zabbixTestsOff[tIndex] = {...modifiedData}
                // this.testsOff = this.testsOff.filter(test => test.id !== change.doc.id);
                // this.testsOff.unshift(modifiedData);
              }
                break;
              case "removed":
              {
                const removedData = change.doc.data();
                this.zabbixTestsOff = this.zabbixTestsOff.filter(test => test.id !== removedData.id);
                // this.removeAdminActiveTask({taskId:removedData.id})
              }
                break;
            }
          });
          console.log('Called zabbbx Down...');
          console.log(this.zabbixTestsOff);
          if(this.$refs.downZabbixTable) {
            this.$refs.downZabbixTable.groupTestsInAPlan(this.zabbixMonitors)
          }
          if (this.$refs.downTable1) {
            this.$refs.downTable1.groupTestsInAPlan(this.zabbixMonitors);
          }
        });
      }else {
        this.testsOff = [];
        downQuery = db.collection('monitors')
            .where('status', 'in', ['down', 'paused', 'pending'])
            // .orderBy("updatedAt", "desc")
            // .limit(500);
        this.downListener = downQuery.onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            switch (change.type) {
              case 'added':
                this.testsOff = this.testsOff.filter(test => test.id !== change.doc.id);
                this.testsOff.unshift({id: change.doc.id , ...change.doc.data()});
                break;
              case "modified":
              {
                const modifiedData = change.doc.data();
                let tIndex = this.testsOff.findIndex(test => test.id === change.doc.id);
                this.testsOff[tIndex] = {...modifiedData}
                // this.testsOff = this.testsOff.filter(test => test.id !== change.doc.id);
                // this.testsOff.unshift(modifiedData);
              }
                break;
              case "removed":
              {
                const removedData = change.doc.data();
                this.testsOff = this.testsOff.filter(test => test.id !== removedData.id);
                // this.removeAdminActiveTask({taskId:removedData.id})
              }
                break;
            }
          });
          console.log('Called Down...');
          console.log(this.testsOff);

          if(this.$refs.downTable) {
            this.$refs.downTable.groupTestsInAPlan(this.testsOff);
          }
          if (this.$refs.downTable1) {
            this.$refs.downTable1.groupTestsInAPlan(this.testsOff);
          }
        });
      }

      this.$store.dispatch('monitor/updateListeners',
          {
            monitorStatusUpListener: this.upListener,
            monitorStatusDownListener: this.downListener,
          }
      )
      this.loading = true;
    },
  }
}
</script>


<style scoped>

.cursor-pointer{
  cursor: pointer !important;
}
.sc-status {
  width: 20px;
  border-radius: 50%;
  height: 20px;
  display: inline-block;
}

.sc-status.down {
  background-color: #a51f1f;
}

.sc-status.up {
  background-color: #6aa529;
}

.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5B7CFB;
}
.align-bottom{
  display: flex;
  align-items: flex-end;
}
.m-t-1{
  margin-top: -1px;
}
.scroll-area {
  position: relative;
  max-height: 400px;
  overflow: hidden;
}
.scroll-area-modal {
  position: relative;
  max-height: 350px;
  overflow: hidden;
}
</style>

